/*
 *
 * */

import FilterFactory from '@/lib/filterFactory';

export default class SpecializationsFilter {
    filterHandlers = {
        update: 'specializationsFilter/updateFilter',
        reset: 'specializationsFilter/resetFilter',
        resetState: 'specializationsFilter/resetFilterState',
        removeSelected: 'specializationsFilter/removeSelectedFilter',
    };
    filterModel = {};

    constructor() {
        const filter = new FilterFactory();

        filter.createSearchEntity('title');
        filter.setPlaceholder('title', 'По названию');
        filter.setName('title', 'search_title');
        filter.setPreviewName('title', 'Название');
        filter.setClassName('title', 'col-1-row-1');
        filter.setIconClassName('title', 'icon-store');
        filter.setAction('title', 'specializationsFilter/updateSearch');

        filter.createSelectEntity('type');
        filter.setPlaceholder('type', 'По типу');
        filter.setName('type', 'select_type');
        filter.setPreviewName('type', 'Тип');
        filter.setClassName('type', 'col-1-row-2');
        filter.setIconClassName('type', 'icon-store');
        filter.setAction('type', 'specializationsFilter/updateSelect');
        filter.setClearAction('type', 'specializationsFilter/resetSelect');
        filter.setList('type', [
            {id: 'all', value: 'для всех'},
            {id: 'adult', value: 'для взрослых'},
            {id: 'child', value: 'для детей'}
        ])

        filter.createCheckboxEntity('withInactive');
        filter.setIconClassName('withInactive', 'icon-check-mark');
        filter.setName('withInactive', 'checkbox_activity');
        filter.setPreviewName('withInactive', 'Неактив');
        filter.setClassName('type', 'col-1-row-3');
        filter.setCheckboxList('withInactive', [
            {
                id: '0',
                name: 'Показывать деактивированные',
                value: 'withInactive',
                checked: false,
            }
        ]);
        filter.setAction('withInactive', 'specializationsFilter/updateCheckbox');

        this.filterModel = filter.filterModel;
    }
}